import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Products = () => {
  const { t } = useTranslation();

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div>
      <main className="page-content">
        <div className="tm-products-area tm-section tm-padding-section bg-white wishlist-section-ones">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-4 col-12">
                <div className="toggle-two">
                  <div className="div toggle-middle-btn" id="wrapper">
                    <button
                      className="menu-button menu-button-one"
                      type="button"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasExample22"
                      aria-controls="offcanvasExample"
                    >
                      <strong style={{ float: "left", padding: "1px 0 0 0" }}>
                        Filter
                      </strong>
                      <span>
                        <i className="fa fa-filter" />
                      </span>
                    </button>
                    <div
                      className="offcanvas offcanvas-start"
                      tabIndex={-1}
                      id="offcanvasExample22"
                      aria-labelledby="offcanvasExampleLabel"
                    >
                      <div className="offcanvas-header">
                        <h5
                          className="offcanvas-title"
                          id="offcanvasExampleLabel"
                        >
                          All Category
                        </h5>
                        <button
                          type="button"
                          className="btn-close text-reset"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                        />
                      </div>
                      <div className="offcanvas-body">
                        <div>
                          <div className="accordion" id="accordionExample">
                            <div className="accordion-item">
                              <h2 className="accordion-header" id="headingOne">
                                <button
                                  className="accordion-button drop accordion-color"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseOne"
                                  aria-expanded="true"
                                  aria-controls="collapseOne"
                                >
                                  Category
                                </button>
                              </h2>
                              <div
                                id="collapseOne"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body accordion-body-copy1">
                                  <div className="category-four-box">
                                    <form id="fivea">
                                      <div className="form-group-three form-group-five">
                                        <label htmlFor="Embroidered">
                                          Embroidered
                                        </label>
                                      </div>
                                      <div className="form-group-three form-group-five">
                                        <label htmlFor="Solid">Solid</label>
                                      </div>
                                      <div className="form-group-three form-group-five">
                                        <label htmlFor="Printed">Printed</label>
                                      </div>
                                      <div className="form-group-three form-group-five">
                                        <label htmlFor="Embroidery">
                                          Embroidery
                                        </label>
                                      </div>
                                      <div className="form-group-three form-group-five">
                                        <label htmlFor="Tunics">Tunics</label>
                                      </div>
                                      <div className="form-group-three form-group-five">
                                        <label htmlFor="Straight">
                                          Straight
                                        </label>
                                      </div>
                                      <div className="form-group-three form-group-five">
                                        <label htmlFor="A-Line">A-Line</label>
                                      </div>
                                      {/* <div class="form-group-three form-group-five">
                                                          <label for="Diamond">Diamond</label>
                                                      </div>
                                                      <div class="form-group-three form-group-five">
                                                          <label for="Necklace">Necklace</label>
                                                      </div>
                                                      <div class="form-group-three form-group-five">
                                                          <label for="Turquoise">Turquoise</label>
                                                      </div>
                                                      <div class="form-group-three form-group-five">
                                                          <label for="Diamond1">Diamond</label>
                                                      </div> */}
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="accordion-item">
                              <h2 className="accordion-header" id="headingTwo">
                                <button
                                  className="accordion-button collapsed dropaa accordion-color"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseTwo"
                                  aria-expanded="false"
                                  aria-controls="collapseTwo"
                                >
                                  Gender
                                </button>
                              </h2>
                              <div
                                id="collapseTwo"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingTwo"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">Women</div>
                              </div>
                            </div>
                            <div className="accordion-item">
                              <h2
                                className="accordion-header"
                                id="headingThree"
                              >
                                <button
                                  className="accordion-button collapsed dropaa accordion-color"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseThree"
                                  aria-expanded="false"
                                  aria-controls="collapseThree"
                                >
                                  Color
                                </button>
                              </h2>
                              <div
                                id="collapseThree"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <form>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="Beige" />
                                      <label htmlFor="Beige">Beige</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="Grey" />
                                      <label htmlFor="Grey">Grey</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="Blue" />
                                      <label htmlFor="Blue">Blue</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="Brown" />
                                      <label htmlFor="Brown">Brown</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="Multicolor" />
                                      <label htmlFor="Multicolor">
                                        Multicolor
                                      </label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="Pink" />
                                      <label htmlFor="Pink">Light Pink</label>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                            <div className="accordion-item">
                              <h2 className="accordion-header" id="headingfour">
                                <button
                                  className="accordion-button collapsed dropaa accordion-color"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapsefour"
                                  aria-expanded="false"
                                  aria-controls="collapsefour"
                                >
                                  Size
                                </button>
                              </h2>
                              <div
                                id="collapsefour"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingfour"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <form>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="aa" />
                                      <label htmlFor="aa">S</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="bb" />
                                      <label htmlFor="bb">M</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="cc" />
                                      <label htmlFor="cc">L</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="dd" />
                                      <label htmlFor="dd">XL</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="ee" />
                                      <label htmlFor="ee">XXL</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="ff" />
                                      <label htmlFor="ff">XXXL</label>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                            <div className="accordion-item">
                              <h2 className="accordion-header" id="headingfour">
                                <button
                                  className="accordion-button collapsed dropaa accordion-color"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapsefive"
                                  aria-expanded="false"
                                  aria-controls="collapsefive"
                                >
                                  Price
                                </button>
                              </h2>
                              <div
                                id="collapsefive"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingfour"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <form>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="aaa" />
                                      <label htmlFor="aaa">Under ₹ 149</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="bbb" />
                                      <label htmlFor="bbb">Under ₹ 199</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="ccc" />
                                      <label htmlFor="ccc">Under ₹ 249</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="ddd" />
                                      <label htmlFor="ddd">Under ₹ 299</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="eee" />
                                      <label htmlFor="eee">Under ₹ 349</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="fff" />
                                      <label htmlFor="fff">₹ 0 - ₹ 99</label>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                            <div className="accordion-item">
                              <h2 className="accordion-header" id="headingfour">
                                <button
                                  className="accordion-button collapsed dropaa accordion-color"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapsesex"
                                  aria-expanded="false"
                                  aria-controls="collapsesex"
                                >
                                  Rating
                                </button>
                              </h2>
                              <div
                                id="collapsesex"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingfour"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <form>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="aaaa" />
                                      <label htmlFor="aaaa">
                                        2.0 and above
                                      </label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="bbbb" />
                                      <label htmlFor="bbbb">
                                        3.0 and above
                                      </label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="cccc" />
                                      <label htmlFor="cccc">
                                        3.5 and above
                                      </label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="dddd" />
                                      <label htmlFor="dddd">
                                        4.0 and above
                                      </label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="eeee" />
                                      <label htmlFor="eeee">M-Trusted</label>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                            <div className="accordion-item">
                              <h2 className="accordion-header" id="headingfour">
                                <button
                                  className="accordion-button collapsed dropaa accordion-color"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapsesiven"
                                  aria-expanded="false"
                                  aria-controls="collapsesiven"
                                >
                                  Type of Hair
                                </button>
                              </h2>
                              <div
                                id="collapsesiven"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingfour"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <form>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="aaaaa" />
                                      <label htmlFor="aaaaa">
                                        All Hair Type
                                      </label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="bbbbb" />
                                      <label htmlFor="bbbbb">Curly Hair</label>
                                    </div>
                                    <div className="form-group-three">
                                      <input type="checkbox" id="ccccc" />
                                      <label htmlFor="ccccc">
                                        Straight Hair
                                      </label>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="menu"
                    className="widgets widgets-one widgets-two menu-container"
                  >
                    <div className="accordion" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                          <button
                            className="accordion-button drop accordion-color"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            {t("Category")}
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body accordion-body-copy1">
                            <div className="category-four-box">
                              <form id="fivea">
                                <div className="form-group-three form-group-five">
                                  <label htmlFor="Embroidered">
                                    {" "}
                                    {t("Embroidered")}
                                  </label>
                                </div>
                                <div className="form-group-three form-group-five">
                                  <label htmlFor="Solid"> {t("Solid")}</label>
                                </div>
                                <div className="form-group-three form-group-five">
                                  <label htmlFor="Printed">
                                    {" "}
                                    {t("Printed")}
                                  </label>
                                </div>
                                <div className="form-group-three form-group-five">
                                  <label htmlFor="Embroidery">
                                    {" "}
                                    {t("Embroidery")}
                                  </label>
                                </div>
                                <div className="form-group-three form-group-five">
                                  <label htmlFor="Tunics"> {t("Tunics")}</label>
                                </div>
                                <div className="form-group-three form-group-five">
                                  <label htmlFor="Straight">
                                    {" "}
                                    {t("Straight")}
                                  </label>
                                </div>
                                <div className="form-group-three form-group-five">
                                  <label htmlFor="A-Line"> {t("A-Line")}</label>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button collapsed dropaa accordion-color"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            {t("Gender")}
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">{t("Women")}</div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingThree">
                          <button
                            className="accordion-button collapsed dropaa accordion-color"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            {t("Color")}
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <form>
                              <div className="form-group-three">
                                <input type="checkbox" id="Beige" />
                                {t("Beige")}
                                <label htmlFor="Beige"></label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="Grey" /> {t("Grey")}
                                <label htmlFor="Grey"> </label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="Blue" /> {t("Blue")}
                                <label htmlFor="Blue"></label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="Brown" />
                                {t("Brown")}
                                <label htmlFor="Brown"> </label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="Multicolor" />{" "}
                                {t("Multicolor")}
                                <label htmlFor="Multicolor"> </label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="Pink" /> {t("Pink")}
                                <label htmlFor="Pink"></label>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingfour">
                          <button
                            className="accordion-button collapsed dropaa accordion-color"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefour"
                            aria-expanded="false"
                            aria-controls="collapsefour"
                          >
                           {t("Size")}
                          </button>
                        </h2>
                        <div
                          id="collapsefour"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingfour"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <form>
                              <div className="form-group-three">
                                <input type="checkbox" id="aa" />
                                <label htmlFor="aa">{t("S")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="bb" />
                                <label htmlFor="bb">{t("M")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="cc" />
                                <label htmlFor="cc">{t("L")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="dd" />
                                <label htmlFor="dd">{t("XL")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="ee" />
                                <label htmlFor="ee">{t("XXL")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="ff" />
                                <label htmlFor="ff">{t("XXXL")}</label>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingfour">
                          <button
                            className="accordion-button collapsed dropaa accordion-color"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefive"
                            aria-expanded="false"
                            aria-controls="collapsefive"
                          >
                           {t("Price")}
                          </button>
                        </h2>
                        <div
                          id="collapsefive"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingfour"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <form>
                              <div className="form-group-three">
                                <input type="checkbox" id="aaa" />
                                <label htmlFor="aaa">{t("Under ₹ 149")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="bbb" />
                                <label htmlFor="bbb">{t("Under ₹ 199")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="ccc" />
                                <label htmlFor="ccc">{t("Under ₹ 249")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="ddd" />
                                <label htmlFor="ddd">{t("Under ₹ 299")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="eee" />
                                <label htmlFor="eee">{t("Under ₹ 349")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="fff" />
                                <label htmlFor="fff">{t("₹ 0 - ₹ 99")}</label>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingfour">
                          <button
                            className="accordion-button collapsed dropaa accordion-color"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsesex"
                            aria-expanded="false"
                            aria-controls="collapsesex"
                          >
                            {t("Rating")}
                          </button>
                        </h2>
                        <div
                          id="collapsesex"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingfour"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <form>
                              <div className="form-group-three">
                                <input type="checkbox" id="aaaa" />
                                <label htmlFor="aaaa">{t("2.0 and above")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="bbbb" />
                                <label htmlFor="bbbb">{t("3.0 and above")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="cccc" />
                                <label htmlFor="cccc">{t("3.5 and above")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="dddd" />
                                <label htmlFor="dddd">{t("4.0 and above")}</label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="eeee" />
                                <label htmlFor="eeee">{t("M-Trusted")}</label>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingfour">
                          <button
                            className="accordion-button collapsed dropaa accordion-color"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsesiven"
                            aria-expanded="false"
                            aria-controls="collapsesiven"
                          >
                           {t("Type of Hair")}
                          </button>
                        </h2>
                        <div
                          id="collapsesiven"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingfour"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <form>
                              <div className="form-group-three">
                                <input type="checkbox" id="aaaaa" />
                           {t("All Hair Type")}
                           <label htmlFor="aaaaa"></label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="bbbbb" />
                           {t("Curly Hair")}
                           <label htmlFor="bbbbb"></label>
                              </div>
                              <div className="form-group-three">
                                <input type="checkbox" id="ccccc" />
                           {t("Straight Hair")}
                           <label htmlFor="ccccc"></label>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-9 col-md-8 col-12">
                <form action="#" className="tm-shop-header">
                  <div className="tm-shop-productview tm-shop-header-aa">
                    <span>{t("view")}:</span>
                    <button data-view="grid" className="active">
                      <i className="ion-android-apps" />
                    </button>
                    <button data-view="list">
                      <i className="ion-android-menu" />
                    </button>
                  </div>
                  <p className="tm-shop-countview tm-shop-header-aa">
                    {t("Showing 1 to 9 of 16")}
                  </p>
                  <select className="tm-shop-header-aa">
                    <option value="value">{t("Default Sorting")}</option>
                    <option value="value">{t("Name A-Z")}</option>
                    <option value="value">{t("Date")}</option>
                    <option value="value">{t("Best Sellers")}</option>
                    <option value="value">{t("Trending")}</option>
                  </select>
                </form>
                <div className="tm-shop-products">
                  <div className="row mt-30-reverse">
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <Link to="/Productdetails">
                              <div className="tm-product-images product-images-two">
                                <img
                                  src="assets/images/product-shop-a.jpg"
                                  alt="product image"
                                />
                                <img
                                  src="assets/images/product-shop-aa.jpg"
                                  alt="product image"
                                />
                              </div>
                            </Link>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                           {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <Link
                              to="/Productdetails"
                              onClick={handleLinkClick}
                            >
                              <div className="tm-product-images product-images-two">
                                <img
                                  src="assets/images/product-shop-b.jpg"
                                  alt="product image"
                                />
                                <img
                                  src="assets/images/product-shop-bb.jpg"
                                  alt="product image"
                                />
                              </div>
                            </Link>
                            <div className="tm-product-badges">
                              <span className="tm-product-badges-new">
                                Sale
                              </span>
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-shop-c.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-shop-cc.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-shop-d.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-shop-dd.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-shop-e.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-shop-ee.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges">
                              <span className="tm-product-badges-new">
                                Sale
                              </span>
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-shop-f.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-shop-ff.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges">
                              <span className="tm-product-badges-new">
                                Sale
                              </span>
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-shop-g.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-shop-gg.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-shop-h.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-shop-hh.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges">
                              <span className="tm-product-badges-new">
                                Sale
                              </span>
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-1.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-2.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-3.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-4.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-5.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-55.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges">
                              <span className="tm-product-badges-new">
                                Sale
                              </span>
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-6.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-66.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges">
                              <span className="tm-product-badges-new">
                                Sale
                              </span>
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-7.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-77.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-8.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-88.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges">
                              <span className="tm-product-badges-new">
                                Sale
                              </span>
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-9.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-99.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                          {t("Product description")}
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-20 middle-two-slide">
                      <div className="tm-product tm-scrollanim">
                        <div className="tm-product-topside">
                          <Link to="/Productdetails" onClick={handleLinkClick}>
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-10.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-110.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </Link>
                        </div>
                        <div className="tm-product-bottomside">
                          <h6 className="tm-product-title">
                            Purple LIVA Straight Kurta
                          </h6>
                          <span className="tm-product-price-two">
                            <b>₹1,199</b>
                          </span>
                          <span className="product-price-three tm-product-price-two">
                            ₹1,999
                          </span>
                          <span className="product-price-four">40% OFF</span>
                          <ul className="products-color">
                            <li className="products-color-a" />
                            <li className="products-color-b" />
                            <li className="products-color-c" />
                            <li className="products-color-d" />
                            <li className="products-color-e" />
                            <li className="products-color-f" />
                            <li className="products-color-g" />
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tm-pagination mt-50">
                  <ul>
                    <li className="is-active">
                      {" "}
                      <Link to="/Products" onClick={handleLinkClick}>
                        {" "}
                        1{" "}
                      </Link>{" "}
                    </li>
                    <li>
                      {" "}
                      <Link to="/Products" onClick={handleLinkClick}>
                        {" "}
                        2{" "}
                      </Link>{" "}
                    </li>
                    <li>
                      {" "}
                      <Link to="/Products" onClick={handleLinkClick}>
                        {" "}
                        3{" "}
                      </Link>{" "}
                    </li>
                    <li>
                      {" "}
                      <Link to="/Products" onClick={handleLinkClick}>
                        {" "}
                        4{" "}
                      </Link>{" "}
                    </li>
                    <li>
                      <Link to="/products" onClick={handleLinkClick}>
                        <i className="ion-chevron-right" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Products;
